import React, { PureComponent } from 'react'
import { Header, Grid, Segment, Modal, Loader, Dimmer } from 'semantic-ui-react'
import _ from 'lodash'

import ImageCompressor from 'image-compressor.js'
import firebase from 'firebase/app'
import AddMenu from './AddMenu'
import CategoryList from './CategoryList'
import SaveCategories from './SaveSelectedCategories'
import ImageUpload from '../../../services/ImageUpload'

export default class MenuList extends PureComponent {
  state = {
    uploading: false,
    compressing: false,
    selectedMenuId: null,
    selectedCategoryId: null,
  }

  saveData = async file => {
    try {
      const { fetchMenus } = this.props
      const { selectedCategoryId, selectedMenuId } = this.state

      const updates = {}
      updates[`/menus/${selectedMenuId}/categories/${selectedCategoryId}/image`] = file
      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) {
        alert(err)
      } else fetchMenus()
    } finally {
      this.setState({ uploading: false })
    }
  }

  onUpload = e => {
    const file = e.target.files[0]

    if (file) {
      try {
        this.compress(file)
      } catch (err) {
        alert(err)
      }
    }
  }

  upload = async file => {
    const { selectedCategoryId, selectedMenuId } = this.state

    try {
      const categoryImageUpload = new ImageUpload(file, 'image', {
        destination: `category/${selectedCategoryId}`,
        type: `cate_image`,
        firebaseSavePath: `/menus/${selectedMenuId}/categories/${selectedCategoryId}/compress_image`,
        manipulation: {
          width: 700,
          height: 0,
          size: 15000,
        },
      })

      const { originalUrl } = await categoryImageUpload.upload()
      this.saveData(originalUrl)
    } catch (err) {
      this.setState({ uploading: false })
      alert('There is problem while uploading file. Please try again.', err)
    }
  }

  compress = file => {
    const self = this
    this.setState({ compressing: true })

    const imageCompressor = new ImageCompressor()

    imageCompressor
      .compress(file, { quality: 0.6 })
      .then(result => {
        self.setState({ compressing: false, uploading: true }, () => {
          self.upload(result)
        })
      })
      .catch(() => {
        alert('There is problem while while compressing file. Please try again.')
      })
  }

  renderUploadingModal = () => {
    const { compressing, uploading } = this.state
    const loading = compressing || uploading

    return (
      <Modal size="Mini" open={loading} style={{ width: 250, height: 100 }}>
        <Modal.Actions>
          <Dimmer active={loading} inverted>
            <Loader>Uploading Image</Loader>
          </Dimmer>
        </Modal.Actions>
      </Modal>
    )
  }

  openFileUpload = (selectedMenuId, selectedCategoryId) => {
    this.setState({ selectedMenuId, selectedCategoryId })

    this.imageInput.click()
  }

  render() {
    const { fetchMenus, menus, selected, onChange } = this.props

    return (
      <Grid>
        <Grid.Column width="16">
          <Segment color="black">
            <div
              style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Header style={{ margin: 0 }} size="large">
                All Category
              </Header>
              <AddMenu {...this.props} />
            </div>

            <div style={{ marginTop: 20 }}>
              {_.map(menus, (eachMenu, key) => (
                <CategoryList
                  key={key}
                  menu={eachMenu}
                  menuKey={key}
                  selected={selected}
                  onChange={onChange}
                  fetchMenus={fetchMenus}
                  openFileUpload={this.openFileUpload}
                />
              ))}
            </div>
            {_.size(menus) > 0 && <SaveCategories {...this.props} />}

            <input
              hidden
              type="file"
              accept="image/*"
              onChange={this.onUpload}
              ref={input => {
                this.imageInput = input
              }}
            />
            {this.renderUploadingModal()}
          </Segment>
        </Grid.Column>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/category/components/MenuList.js